import dayjs from 'dayjs';

const EXPIRE_DAYS = 7;

const cookieSet = (name, value) => {
    const exp = new Date(Date.now() + EXPIRE_DAYS * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(JSON.stringify(value))}; expires=${exp}; path=/`;
};

const cookieGet = (name) => {
    const match = document.cookie.split('; ').find(row => row.startsWith(name + '='));
    if (!match) return null;
    try {
        return JSON.parse(decodeURIComponent(match.slice(name.length + 1)));
    } catch {
        return null;
    }
};

const cookieRemove = (name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
};

export const useTableCookie = (cookieKey) => {
    const K = {
        search: `${cookieKey}_s`,
        pagination: `${cookieKey}_p`,
        active: `${cookieKey}_a`,
    };

    const getSearch = (dateFields = []) => {
        const saved = cookieGet(K.search) || {};
        dateFields.forEach(field => {
            if (Array.isArray(saved[field]) && saved[field].length === 2) {
                saved[field] = saved[field].map(d => dayjs(d));
            }
        });
        return saved;
    };

    const saveSearch = (values, dateFields = []) => {
        const data = { ...values };
        Object.keys(data).forEach(k => {
            if (data[k] === undefined || data[k] === null) delete data[k];
        });
        dateFields.forEach(field => {
            if (Array.isArray(data[field]) && data[field].length > 0 && dayjs.isDayjs(data[field][0])) {
                data[field] = data[field].map(d => d.format('YYYY-MM-DD'));
            }
        });
        cookieSet(K.search, data);
    };

    const getPagination = () => cookieGet(K.pagination) || { current: 1, pageSize: 10 };

    const savePagination = (p) => {
        cookieSet(K.pagination, { current: p.current, pageSize: p.pageSize });
    };

    const getActiveSearch = () => cookieGet(K.active) || [];

    const saveActiveSearch = (v) => {
        cookieSet(K.active, v);
    };

    const clearSearch = () => {
        cookieRemove(K.search);
        cookieRemove(K.pagination);
    };

    return {
        getSearch,
        saveSearch,
        getPagination,
        savePagination,
        getActiveSearch,
        saveActiveSearch,
        clearSearch,
    };
};
